(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1401],{

/***/ 64755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": function() { return /* binding */ useGetReservationFlowEventSchemePaymentMethodList; },
/* harmony export */   "Mo": function() { return /* binding */ useRevalidateGetReservationFlowEventSchemePaymentMethodList; }
/* harmony export */ });
/* unused harmony export getGetReservationFlowEventSchemePaymentMethodListKey */
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95591);
/* harmony import */ var _openapi_axiosClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39428);





var getGetReservationFlowEventSchemePaymentMethodListKey = function getGetReservationFlowEventSchemePaymentMethodListKey(_ref) {
  var parameter = _ref.parameter;
  return {
    path: '/api/reservation_flow/merchants/{merchant_public_id}/event_scheme/resources/{resource_public_id}/payment_method_list',
    parameter: parameter
  };
};
var useGetReservationFlowEventSchemePaymentMethodList = function useGetReservationFlowEventSchemePaymentMethodList(_ref2) {
  var parameter = _ref2.parameter;
  var key = getGetReservationFlowEventSchemePaymentMethodListKey({
    parameter: parameter
  });

  var fetcher = /*#__PURE__*/function () {
    var _ref3 = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var client, result;
      return _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              client = (0,_openapi_axiosClient__WEBPACK_IMPORTED_MODULE_3__/* .getApiClient */ .sT)();
              _context.prev = 1;
              _context.next = 4;
              return client.getReservationFlowEventSchemePaymentMethodList({
                parameter: parameter
              });

            case 4:
              result = _context.sent;
              return _context.abrupt("return", result);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              throw _context.t0;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function fetcher() {
      return _ref3.apply(this, arguments);
    };
  }();

  return (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(key, fetcher);
};
var useRevalidateGetReservationFlowEventSchemePaymentMethodList = function useRevalidateGetReservationFlowEventSchemePaymentMethodList(_ref4) {
  var parameter = _ref4.parameter;

  var _useSWRConfig = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* .useSWRConfig */ .kY)(),
      mutate = _useSWRConfig.mutate;

  var revalidateGetReservationFlowEventSchemePaymentMethodList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/(0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
    return _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return mutate(getGetReservationFlowEventSchemePaymentMethodListKey({
              parameter: parameter
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [parameter, mutate]);
  return {
    revalidateGetReservationFlowEventSchemePaymentMethodList: revalidateGetReservationFlowEventSchemePaymentMethodList
  };
};

/***/ }),

/***/ 51411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iq": function() { return /* binding */ useRevalidateGetReservationFlowEventSchemeResource; },
/* harmony export */   "pj": function() { return /* binding */ useGetReservationFlowEventSchemeResource; }
/* harmony export */ });
/* unused harmony export getGetReservationFlowEventSchemeResourceKey */
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95591);
/* harmony import */ var _openapi_axiosClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39428);





var getGetReservationFlowEventSchemeResourceKey = function getGetReservationFlowEventSchemeResourceKey(_ref) {
  var parameter = _ref.parameter;
  return {
    path: '/api/reservation_flow/merchants/{merchant_public_id}/event_scheme/resources/{resource_public_id}',
    parameter: parameter
  };
};
var useGetReservationFlowEventSchemeResource = function useGetReservationFlowEventSchemeResource(_ref2) {
  var parameter = _ref2.parameter;
  var key = getGetReservationFlowEventSchemeResourceKey({
    parameter: parameter
  });

  var fetcher = /*#__PURE__*/function () {
    var _ref3 = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var client, result;
      return _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              client = (0,_openapi_axiosClient__WEBPACK_IMPORTED_MODULE_3__/* .getApiClient */ .sT)();
              _context.prev = 1;
              _context.next = 4;
              return client.getReservationFlowEventSchemeResource({
                parameter: parameter
              });

            case 4:
              result = _context.sent;
              return _context.abrupt("return", result);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              throw _context.t0;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function fetcher() {
      return _ref3.apply(this, arguments);
    };
  }(); // 保護されたページなど401エラーが発生する可能性があるため、shouldRetryOnErrorをfalseに設定する


  return (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(key, fetcher, {
    shouldRetryOnError: false
  });
};
var useRevalidateGetReservationFlowEventSchemeResource = function useRevalidateGetReservationFlowEventSchemeResource(_ref4) {
  var parameter = _ref4.parameter;

  var _useSWRConfig = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* .useSWRConfig */ .kY)(),
      mutate = _useSWRConfig.mutate;

  var revalidateGetReservationFlowEventSchemeResource = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/(0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
    return _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return mutate(getGetReservationFlowEventSchemeResourceKey({
              parameter: parameter
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [parameter, mutate]);
  return {
    revalidateGetReservationFlowEventSchemeResource: revalidateGetReservationFlowEventSchemeResource
  };
};

/***/ }),

/***/ 2244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ RSButtonLink; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@react-aria/focus/dist/module.js + 2 modules
var dist_module = __webpack_require__(35044);
// EXTERNAL MODULE: ./node_modules/@react-aria/utils/dist/module.js
var utils_dist_module = __webpack_require__(83952);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/reservation-page/RSButtonAnchor/index.module.css
var index_module = __webpack_require__(82011);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/reservation-page/RSButtonAnchor/index.tsx


var _excluded = ["variant", "isBlock", "isDisabled", "children"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var RSButtonAnchor = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'basic' : _ref$variant,
      _ref$isBlock = _ref.isBlock,
      isBlock = _ref$isBlock === void 0 ? false : _ref$isBlock,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFocusRing = (0,dist_module/* useFocusRing */.Fx)(),
      isFocusVisible = _useFocusRing.isFocusVisible,
      focusProps = _useFocusRing.focusProps;

  var color = '#0066FF';
  var wrapperHeightClasses = (0,react.useMemo)(function () {
    switch (variant) {
      case 'large':
        return ['h-56'];

      case 'basic':
      case 'outline':
      case 'destructive':
        return ['h-48', 'pc:h-44'];
    }
  }, [variant]);
  var buttonSizeClasses = (0,react.useMemo)(function () {
    switch (variant) {
      case 'large':
        return ['px-[20px]'];

      case 'basic':
      case 'outline':
      case 'destructive':
        return ['px-2'];
    }
  }, [variant]);
  var buttonColorClasses = (0,react.useMemo)(function () {
    switch (variant) {
      case 'large':
        return [isDisabled && 'bg-gray-10', !isDisabled ? 'text-white' : 'text-gray-200', isDisabled && 'border-gray-10'];

      case 'basic':
        return [isDisabled && 'bg-gray-10', !isDisabled ? 'text-white' : 'text-gray-200', isDisabled && 'border-gray-10'];

      case 'outline':
        return [!isDisabled ? 'bg-white' : 'bg-gray-10', isDisabled && 'text-gray-200', !isDisabled ? 'border-gray-200' : 'border-gray-10'];

      case 'destructive':
        return [!isDisabled ? 'bg-white' : 'bg-gray-10', !isDisabled ? 'text-red-700' : 'text-gray-200', !isDisabled ? 'border-gray-200' : 'border-gray-10'];
    }
  }, [variant, isDisabled]);
  var isButtonBackgroundColorPrimary = (0,react.useMemo)(function () {
    if (isDisabled) {
      return false;
    }

    if (variant !== 'large' && variant !== 'basic') {
      return false;
    }

    return true;
  }, [variant, isDisabled]);
  var isButtonTextColorPrimary = (0,react.useMemo)(function () {
    if (isDisabled) {
      return false;
    }

    if (variant !== 'outline') {
      return false;
    }

    return true;
  }, [variant, isDisabled]);
  var isButtonBorderColorPrimary = (0,react.useMemo)(function () {
    if (isDisabled) {
      return false;
    }

    if (variant !== 'large' && variant !== 'basic') {
      return false;
    }

    return true;
  }, [variant, isDisabled]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "jsx-3362828503" + " " + (classnames_default()('wrapper', isFocusVisible && 'focus-visible', !isBlock ? 'inline-block' : ['block', 'w-full'], 'relative', wrapperHeightClasses, 'rounded-15', 'after:transition', // cursor-event-noneとcursor-not-allowedを同じ要素で利用できないため
      !isDisabled ? 'cursor-pointer' : 'cursor-not-allowed') || ""),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", _objectSpread(_objectSpread({}, (0,utils_dist_module/* mergeProps */.dG)(props, focusProps)), {}, {
        ref: ref,
        tabIndex: !isDisabled ? undefined : -1,
        className: "jsx-3362828503" + " " + (classnames_default()('button', isButtonBackgroundColorPrimary && 'bg-primary', isButtonTextColorPrimary && 'text-primary', isButtonBorderColorPrimary && 'border-primary', 'relative', buttonSizeClasses, 'box-border', 'w-full', 'h-full', 'flex', 'justify-center', 'items-center', 'border', 'border-solid', 'rounded-15', 'outline-none', 'focus:outline-none', buttonColorClasses, 'no-underline', 'z-1', 'transition', !isDisabled && (index_module_default())["button--default"], isDisabled && 'pointer-events-none') || ""),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "jsx-3362828503" + " " + "rs-font whitespace-nowrap text-16 font-bold pc:text-15",
          children: children
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: "3362828503",
      children: [".wrapper.jsx-3362828503::after{content:'';box-sizing:border-box;position:absolute;width:calc(100% + 8px);height:calc(100% + 8px);top:-4px;left:-4px;border-style:solid;border-width:2px;border-color:transparent;border-radius:18px;}", ".wrapper.focus-visible.jsx-3362828503::after{border-color:".concat(color, ";}"), ".button.bg-primary.jsx-3362828503{background-color:".concat(color, ";}"), ".button.text-primary.jsx-3362828503{color:".concat(color, ";}"), ".button.border-primary.jsx-3362828503{border-color:".concat(color, ";}")]
    })]
  });
});
;// CONCATENATED MODULE: ./src/reservation-page/RSButtonLink/index.tsx


var RSButtonLink_excluded = ["children", "variant", "isBlock", "isDisabled"];

function RSButtonLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RSButtonLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RSButtonLink_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RSButtonLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var RSButtonLink = function RSButtonLink(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      isBlock = _ref.isBlock,
      isDisabled = _ref.isDisabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, RSButtonLink_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), RSButtonLink_objectSpread(RSButtonLink_objectSpread({}, props), {}, {
    passHref: true,
    legacyBehavior: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButtonAnchor, {
      variant: variant,
      isBlock: isBlock,
      isDisabled: isDisabled,
      children: children
    })
  }));
};

/***/ }),

/***/ 96760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ RSDescriptionList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var RSDescriptionList = function RSDescriptionList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("dl", {
    className: "m-0 box-border border-x-0 border-y border-solid border-gray-50 bg-white",
    children: children
  });
};

/***/ }),

/***/ 68176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ RSDescriptionListItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var RSDescriptionListItem = function RSDescriptionListItem(_ref) {
  var term = _ref.term,
      description = _ref.description;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "box-border border-b border-l-0 border-r-0 border-t-0 border-solid border-gray-50  p-1.5 last-of-type:border-b-0",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("dt", {
      className: "rs-font mb-[2px] text-16 font-bold text-gray-1000 pc:text-15",
      children: term
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("dd", {
      className: "m-0",
      children: description
    })]
  });
};

/***/ }),

/***/ 90016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ RSDetailHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var RSDetailHeader = function RSDetailHeader(_ref) {
  var title = _ref.title,
      leftButton = _ref.leftButton,
      rightButton = _ref.rightButton,
      isNoBorder = _ref.isNoBorder;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('relative', 'box-border', !isNoBorder ? 'h-[59px]' : 'h-[56px]', 'w-full', 'bg-white', 'px-1', !isNoBorder && 'border-b-[3px] border-l-0 border-r-0 border-t-0 border-solid border-gray-10'),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "box-border flex h-full w-full justify-between",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "box-border flex h-full basis-[104px] items-center justify-start",
        children: leftButton && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: leftButton
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "box-border flex h-full flex-auto items-center justify-center truncate px-2",
        children: title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "rs-font box-border truncate text-center text-16 font-normal leading-[1.4] text-gray-1000 pc:text-15 pc:leading-[1.4]",
          children: title
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "box-border flex h-full basis-[104px] items-center justify-end",
        children: rightButton && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: rightButton
        })
      })]
    })
  });
};

/***/ }),

/***/ 15247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ RSDetailHeaderButton; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _react_aria_focus__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35044);
/* harmony import */ var _react_aria_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83952);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _heyinc_stand_ui_icons_svg_spinner_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96716);
/* harmony import */ var _index_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46490);
/* harmony import */ var _index_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


var _excluded = ["variant", "isLoading", "children"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var RSDetailHeaderButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'close' : _ref$variant,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      children = _ref.children,
      props = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, _excluded);

  var disabled = props.disabled;

  var _useFocusRing = (0,_react_aria_focus__WEBPACK_IMPORTED_MODULE_7__/* .useFocusRing */ .Fx)(),
      isFocusVisible = _useFocusRing.isFocusVisible,
      focusProps = _useFocusRing.focusProps;

  var color = '#0066FF';
  var colorTint = '#F1F7FF';
  var wrapperClasses = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    switch (variant) {
      case 'close':
        return ['min-w-[80px]'];

      case 'ok':
        return ['min-w-[80px]'];

      case 'okText':
        return [];

      case 'destruction':
        return ['min-w-[80px]'];
    }
  }, [variant]);
  var buttonSizeClasses = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    switch (variant) {
      case 'close':
        return ['px-2'];

      case 'ok':
        return ['px-2'];

      case 'okText':
        return ['px-1.5'];

      case 'destruction':
        return ['px-2'];
    }
  }, [variant]);
  var buttonColorClasses = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    // closeとdestructionはdisabledのスタイルを持っていないが、
    // isLoadingとdisabledを合わせて利用する可能性があるため不自然でない色を指定している。
    switch (variant) {
      case 'close':
        return ['bg-gray-10', 'text-gray-1000', 'border-gray-10'];

      case 'ok':
        return [(disabled || isLoading) && 'bg-gray-10', !disabled && !isLoading ? 'text-white' : 'text-gray-200', (disabled || isLoading) && 'border-gray-10'];

      case 'okText':
        return ['bg-white', (disabled || isLoading) && 'text-gray-200', 'border-white'];

      case 'destruction':
        return [(disabled || isLoading) && 'bg-gray-10', (disabled || isLoading) && 'border-gray-10'];
    }
  }, [variant, disabled, isLoading]);
  var isButtonBackgroundColorPrimary = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    if (disabled || isLoading) {
      return false;
    }

    if (variant !== 'ok') {
      return false;
    }

    return true;
  }, [variant, disabled, isLoading]);
  var isButtonBackgroundColorPrimaryTint = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    if (disabled || isLoading) {
      return false;
    }

    if (variant !== 'destruction') {
      return false;
    }

    return true;
  }, [variant, disabled, isLoading]);
  var isButtonTextColorPrimary = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    if (disabled || isLoading) {
      return false;
    }

    if (variant !== 'okText' && variant !== 'destruction') {
      return false;
    }

    return true;
  }, [variant, disabled, isLoading]);
  var isButtonBorderColorPrimary = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    if (disabled || isLoading) {
      return false;
    }

    if (variant !== 'ok' && variant !== 'destruction') {
      return false;
    }

    return true;
  }, [variant, disabled, isLoading]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "jsx-389623718" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()('wrapper', isFocusVisible && 'focus-visible', 'inline-block', 'relative', 'box-border', wrapperClasses, 'h-[40px]', 'rounded-[12px]', 'after:transition') || ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("button", _objectSpread(_objectSpread({}, (0,_react_aria_utils__WEBPACK_IMPORTED_MODULE_8__/* .mergeProps */ .dG)(props, focusProps)), {}, {
        ref: ref,
        className: "jsx-389623718" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()('button', isButtonBackgroundColorPrimary && 'bg-primary', isButtonBackgroundColorPrimaryTint && 'bg-primary-tint', isButtonTextColorPrimary && 'text-primary', isButtonBorderColorPrimary && 'border-primary', 'relative', 'box-border', buttonSizeClasses, 'w-full', 'h-full', 'flex', 'justify-center', 'items-center', 'border', 'border-solid', 'rounded-[12px]', 'outline-none', 'focus:outline-none', buttonColorClasses, 'z-1', 'transition', !disabled ? 'cursor-pointer' : 'cursor-not-allowed', !disabled && !isLoading && (_index_module_css__WEBPACK_IMPORTED_MODULE_9___default()["button--default"])) || ""),
        children: [isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "jsx-389623718" + " " + "absolute left-0 top-0 flex h-full w-full items-center justify-center",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "jsx-389623718" + " " + ((_index_module_css__WEBPACK_IMPORTED_MODULE_9___default()["icon-wrapper"]) || ""),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_heyinc_stand_ui_icons_svg_spinner_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              width: "24",
              height: "24",
              viewBox: "0 0 48 48",
              className: "fill-gray-200"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "jsx-389623718" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()('rs-font', 'text-16', 'pc:text-15', 'font-bold', 'whitespace-nowrap', isLoading && 'invisible') || ""),
          children: children
        })]
      }))
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "389623718",
      children: [".wrapper.jsx-389623718::after{content:'';box-sizing:border-box;position:absolute;width:calc(100% + 8px);height:calc(100% + 8px);top:-4px;left:-4px;border-style:solid;border-width:2px;border-color:transparent;border-radius:16px;}", ".wrapper.focus-visible.jsx-389623718::after{border-color:".concat(color, ";}"), ".button.bg-primary.jsx-389623718{background-color:".concat(color, ";}"), ".button.bg-primary-tint.jsx-389623718{background-color:".concat(colorTint, ";}"), ".button.text-primary.jsx-389623718{color:".concat(color, ";}"), ".button.border-primary.jsx-389623718{border-color:".concat(color, ";}")]
    })]
  });
});
RSDetailHeaderButton.displayName = 'RSDetailHeaderButton';

/***/ }),

/***/ 79857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ useIsMobile; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/reservation-page/hooks/helpers/useMediaQuery/index.tsx

var useMediaQuery = function useMediaQuery(query) {
  var supportsMatchMedia =  true && typeof window.matchMedia === 'function';

  var _useState = (0,react.useState)(function () {
    return supportsMatchMedia ? window.matchMedia(query).matches : false;
  }),
      matches = _useState[0],
      setMatches = _useState[1];

  var ref = (0,react.useRef)(query);
  (0,react.useEffect)(function () {
    ref.current = query;
  });
  var prevQuery = ref.current;
  (0,react.useEffect)(function () {
    if (!supportsMatchMedia) {
      return;
    }

    var mq = window.matchMedia(query);

    var onChange = function onChange(evt) {
      setMatches(evt.matches);
    };

    mq.addEventListener('change', onChange); // 引数に変更あった際にも更新

    if (prevQuery !== query) {
      setMatches(window.matchMedia(query).matches);
    }

    return function () {
      mq.removeEventListener('change', onChange);
    };
  }, [supportsMatchMedia, query, prevQuery]);
  return matches;
};
;// CONCATENATED MODULE: ./src/reservation-page/hooks/helpers/useIsMobile/index.ts

var useIsMobile = function useIsMobile() {
  return useMediaQuery('(max-width: 519px)');
};

/***/ }),

/***/ 376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useReactModalAnimationWorkaround; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// このcustom hookはreact-modalのSafariでのアニメーションの問題を解決するためにあります。
// https://stackoverflow.com/questions/65072058/react-modal-animation-doesnt-work-in-safari
var useReactModalAnimationWorkaround = function useReactModalAnimationWorkaround(initialValue) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue),
      wasOpen = _useState[0],
      setWasOpen = _useState[1];

  var afterOpenModal = function afterOpenModal() {
    setTimeout(function () {
      setWasOpen(true);
    }, 0);
  };

  var afterClose = function afterClose() {
    setTimeout(function () {
      setWasOpen(false);
    }, 0);
  };

  return {
    afterOpenModal: afterOpenModal,
    afterClose: afterClose,
    wasOpen: wasOpen
  };
};

/***/ }),

/***/ 79061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ RSModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_helpers_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79857);
/* harmony import */ var _hooks_helpers_useReactModalAnimationWorkaround__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(376);
/* harmony import */ var _detail_header_RSDetailHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90016);
/* harmony import */ var _detail_header_RSDetailHeaderButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15247);
/* harmony import */ var _index_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80957);
/* harmony import */ var _index_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);










var RSModal = function RSModal(_ref) {
  var title = _ref.title,
      isOpen = _ref.isOpen,
      closeText = _ref.closeText,
      onRequireClosing = _ref.onRequireClosing,
      rightButton = _ref.rightButton,
      isDetailHeaderNoBorder = _ref.isDetailHeaderNoBorder,
      children = _ref.children;
  var isMobile = (0,_hooks_helpers_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* .useIsMobile */ .d)();

  var _useReactModalAnimati = (0,_hooks_helpers_useReactModalAnimationWorkaround__WEBPACK_IMPORTED_MODULE_4__/* .useReactModalAnimationWorkaround */ .x)(false),
      afterOpenModal = _useReactModalAnimati.afterOpenModal,
      afterClose = _useReactModalAnimati.afterClose,
      wasOpen = _useReactModalAnimati.wasOpen;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    appElement: document.getElementById('__next') !== null ? document.getElementById('__next') : undefined,
    className: {
      base: classnames__WEBPACK_IMPORTED_MODULE_2___default()(isMobile ? 'w-full' : 'max-w-[560px]', isMobile ? 'rounded-t-20' : 'rounded-15', isMobile ? 'mt-2' : 'mt-[80px]', isMobile && 'bottom-0', !isMobile && 'mx-auto', 'bg-white', 'overflow-hidden', isMobile ? (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().spContentBase) : (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().contentBase)),
      afterOpen: classnames__WEBPACK_IMPORTED_MODULE_2___default()(wasOpen && (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().contentBaseAfterOpen), isMobile && (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().spContentAfterOpen)),
      beforeClose: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().contentBaseBeforeClose), isMobile && (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().spContentBeforeClose))
    },
    overlayClassName: {
      base: classnames__WEBPACK_IMPORTED_MODULE_2___default()('fixed', 'z-8', !isMobile && 'px-4', (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().overlayBase)),
      afterOpen: classnames__WEBPACK_IMPORTED_MODULE_2___default()(wasOpen && (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().overlayBaseAfterOpen)),
      beforeClose: (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().overlayBaseBeforeClose)
    },
    closeTimeoutMS: 150,
    onRequestClose: onRequireClosing,
    onAfterOpen: afterOpenModal,
    onAfterClose: afterClose,
    isOpen: isOpen,
    shouldFocusAfterRender: false,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_detail_header_RSDetailHeader__WEBPACK_IMPORTED_MODULE_5__/* .RSDetailHeader */ .N, {
      title: title,
      leftButton: closeText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_detail_header_RSDetailHeaderButton__WEBPACK_IMPORTED_MODULE_6__/* .RSDetailHeaderButton */ .R, {
        variant: "close",
        onClick: onRequireClosing,
        children: closeText
      }),
      rightButton: rightButton,
      isNoBorder: isDetailHeaderNoBorder
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('overflow-y-auto', isMobile ? (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().mobileHeightRestriction) : (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default().pcHeightRestriction)),
      children: children
    })]
  });
};

/***/ }),

/***/ 69208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CautionList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47292);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(date_fns__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42180);
/* harmony import */ var date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _reservation_page_description_list_RSDescriptionList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96760);
/* harmony import */ var _reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68176);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);

/* eslint-disable import/no-duplicates */



/* eslint-disable import/no-duplicates */





var CautionList = function CautionList(_ref) {
  var resource = _ref.resource,
      isPrepaymentEnabled = _ref.isPrepaymentEnabled;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_reservation_page_description_list_RSDescriptionList__WEBPACK_IMPORTED_MODULE_3__/* .RSDescriptionList */ .m, {
    children: [function () {
      var start_period = resource.reservable_period.start_period;

      if (start_period === null) {
        return null;
      }

      if (start_period.type === 'no_setup') {
        return null;
      }

      switch (start_period.type) {
        case 'datetime':
          {
            if (start_period.datetime === null) {
              return null;
            }

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
              term: "\u4E88\u7D04\u306E\u53D7\u4ED8\u958B\u59CB",
              description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                children: "".concat((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.format)(new Date(start_period.datetime), 'YYYY年M月D日H時m分', {
                  locale: (date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_2___default())
                }), "\u304B\u3089")
              })
            });
          }

        case 'relative_month':
          {
            if (start_period.relative_month === null) {
              return null;
            }

            var _start_period$relativ = start_period.relative_month,
                base_months = _start_period$relativ.base_months,
                seconds_from_base_months = _start_period$relativ.seconds_from_base_months; // 日付計算を行うため年の最初からの経過秒数を取得

            var dateForCalc = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__.addSeconds)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.startOfYear)(new Date()), seconds_from_base_months);

            var baseMonthString = function () {
              if (base_months === 0) {
                return '当月';
              }

              if (base_months === 1) {
                return '前月';
              }

              return "".concat(base_months, "\u30F6\u6708\u524D");
            }();

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
              term: "\u4E88\u7D04\u306E\u53D7\u4ED8\u958B\u59CB",
              description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                children: "".concat(baseMonthString, "\u306E").concat((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.format)(dateForCalc, 'D日H時m分'), "\u304B\u3089")
              })
            });
          }

        case 'relative_day':
          {
            if (start_period.relative_day === null) {
              return null;
            }

            var _start_period$relativ2 = start_period.relative_day,
                base_days = _start_period$relativ2.base_days,
                seconds_from_base_days = _start_period$relativ2.seconds_from_base_days; // 日付計算を行うため年の最初からの経過秒数を取得

            var _dateForCalc = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__.addSeconds)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.startOfYear)(new Date()), seconds_from_base_days);

            var baseDayString = function () {
              if (base_days === 0) {
                return '当日';
              }

              return "".concat(base_days, "\u65E5\u524D");
            }();

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
              term: "\u4E88\u7D04\u306E\u53D7\u4ED8\u958B\u59CB",
              description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                children: "".concat(baseDayString, "\u306E").concat((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.format)(_dateForCalc, 'H時m分'), "\u304B\u3089")
              })
            });
          }
      }
    }(), function () {
      var end_period = resource.reservable_period.end_period;

      if (end_period === null) {
        return null;
      }

      if (end_period.type === 'no_setup') {
        return null;
      }

      switch (end_period.type) {
        case 'datetime':
          {
            if (end_period.datetime === null) {
              return null;
            }

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
              term: "\u4E88\u7D04\u306E\u53D7\u4ED8\u7DE0\u5207",
              description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                children: "".concat((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.format)(new Date(end_period.datetime), 'YYYY年M月D日H時m分', {
                  locale: (date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_2___default())
                }), "\u307E\u3067")
              })
            });
          }

        case 'relative_month':
          {
            if (end_period.relative_month === null) {
              return null;
            }

            var _end_period$relative_ = end_period.relative_month,
                base_months = _end_period$relative_.base_months,
                seconds_from_base_months = _end_period$relative_.seconds_from_base_months; // 日付計算を行うため年の最初からの経過秒数を取得

            var dateForCalc = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__.addSeconds)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.startOfYear)(new Date()), seconds_from_base_months);

            var baseMonthString = function () {
              if (base_months === 0) {
                return '当月';
              }

              if (base_months === 1) {
                return '前月';
              }

              return "".concat(base_months, "\u30F6\u6708\u524D");
            }();

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
              term: "\u4E88\u7D04\u306E\u53D7\u4ED8\u7DE0\u5207",
              description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                children: "".concat(baseMonthString, "\u306E").concat((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.format)(dateForCalc, 'D日H時m分'), "\u307E\u3067")
              })
            });
          }

        case 'relative_day':
          {
            if (end_period.relative_day === null) {
              return null;
            }

            var _end_period$relative_2 = end_period.relative_day,
                base_days = _end_period$relative_2.base_days,
                seconds_from_base_days = _end_period$relative_2.seconds_from_base_days; // 日付計算を行うため年の最初からの経過秒数を取得

            var _dateForCalc2 = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__.addSeconds)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.startOfYear)(new Date()), seconds_from_base_days);

            var baseDayString = function () {
              if (base_days === 0) {
                return '当日';
              }

              return "".concat(base_days, "\u65E5\u524D");
            }();

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
              term: "\u4E88\u7D04\u306E\u53D7\u4ED8\u7DE0\u5207",
              description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                children: "".concat(baseDayString, "\u306E").concat((0,date_fns__WEBPACK_IMPORTED_MODULE_1__.format)(_dateForCalc2, 'H時m分'), "\u307E\u3067")
              })
            });
          }

        case 'relative':
          {
            if (end_period.relative === null) {
              return null;
            }

            var seconds_from_base_checkin = end_period.relative.seconds_from_base_checkin; // 単位が日の場合

            if (seconds_from_base_checkin > 3600) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
                term: "\u4E88\u7D04\u306E\u53D7\u4ED8\u7DE0\u5207",
                description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                  className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                  children: "".concat(seconds_from_base_checkin / 3600, "\u6642\u9593\u524D\u307E\u3067")
                })
              });
            }

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
              term: "\u4E88\u7D04\u306E\u53D7\u4ED8\u7DE0\u5207",
              description: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                children: "".concat(seconds_from_base_checkin / 60, "\u5206\u524D\u307E\u3067")
              })
            });
          }
      }
    }(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
      term: "\u65E5\u7A0B\u5909\u66F4",
      description: function () {
        if (resource.changeable_until === null || resource.changeable_until === 0) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
            children: "\u65E5\u7A0B\u5909\u66F4\u3092\u53D7\u3051\u4ED8\u3051\u3066\u304A\u308A\u307E\u305B\u3093\u3002"
          });
        } // 単位が日の場合


        if (resource.changeable_until >= 86400) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
            children: "\u4E88\u7D04\u65E5\u6642\u306E".concat(resource.changeable_until / 86400, "\u65E5\u524D\u307E\u3067")
          });
        }

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
          children: "\u4E88\u7D04\u65E5\u6642\u306E".concat(resource.changeable_until / 3600, "\u6642\u9593\u524D\u307E\u3067")
        });
      }()
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_reservation_page_description_list_RSDescriptionListItem__WEBPACK_IMPORTED_MODULE_4__/* .RSDescriptionListItem */ .L, {
      term: "\u30AD\u30E3\u30F3\u30BB\u30EB",
      description: function () {
        if (resource.cancelable_until === null || resource.cancelable_until === 0) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
            children: "\u30AD\u30E3\u30F3\u30BB\u30EB\u3092\u53D7\u3051\u4ED8\u3051\u3066\u304A\u308A\u307E\u305B\u3093\u3002"
          });
        } // 単位が日の場合


        if (resource.cancelable_until >= 86400) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
              children: "\u4E88\u7D04\u65E5\u6642\u306E".concat(resource.cancelable_until / 86400, "\u65E5\u524D\u307E\u3067")
            }), isPrepaymentEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: "rs-font text-13 font-normal text-gray-1000 pc:text-12",
              children: "\u203B\u305F\u3060\u3057\u3001\u4E8B\u524D\u6C7A\u6E08\u306E\u5834\u5408\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u671F\u9650\u3092\u904E\u304E\u3066\u3044\u306A\u304F\u3066\u3082\u3001\u4E88\u7D04\u304B\u3089 25 \u65E5\u304C\u904E\u304E\u308B\u3068\u30AD\u30E3\u30F3\u30BB\u30EB\u3067\u304D\u307E\u305B\u3093"
            })]
          });
        }

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
            children: "\u4E88\u7D04\u65E5\u6642\u306E".concat(resource.cancelable_until / 3600, "\u6642\u9593\u524D\u307E\u3067")
          }), isPrepaymentEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "rs-font text-13 font-normal text-gray-1000 pc:text-12",
            children: "\u203B\u305F\u3060\u3057\u3001\u4E8B\u524D\u6C7A\u6E08\u306E\u5834\u5408\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u671F\u9650\u3092\u904E\u304E\u3066\u3044\u306A\u304F\u3066\u3082\u3001\u4E88\u7D04\u304B\u3089 25 \u65E5\u304C\u904E\u304E\u308B\u3068\u30AD\u30E3\u30F3\u30BB\u30EB\u3067\u304D\u307E\u305B\u3093"
          })]
        });
      }()
    })]
  });
};

/***/ }),

/***/ 17682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ DraftWysiwygViewer; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // デフォルトでSSRを無効化したコンポーネントを提供する


var Raw = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6925), __webpack_require__.e(9041), __webpack_require__.e(2874)]).then(__webpack_require__.bind(__webpack_require__, 72874)).then(function (mod) {
    return mod.Raw;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(72874)];
    }
  }
});
var DraftWysiwygViewer = function DraftWysiwygViewer(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Raw, _objectSpread({}, props));
};

/***/ }),

/***/ 76044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ PaymentMethodsList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var PaymentMethodsList = function PaymentMethodsList(_ref) {
  var resource = _ref.resource;
  var paymentMethodsString = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return resource.enabled_payment_methods.map(function (paymentMethod) {
      switch (paymentMethod) {
        case 'onsite':
          return '現地決済';

        case 'bank_transfer':
          return '銀行振込';

        case 'credit_card':
          return 'クレジットカード決済';

        case 'subscription':
          return '月謝';

        case 'ticket_book':
          return '回数券';
      }
    }).join('・');
  }, [resource]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "m-0 box-border border-x-0 border-y border-solid border-gray-50 bg-white",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "box-border border-b border-l-0 border-r-0 border-t-0 border-solid border-gray-50  p-1.5 last-of-type:border-b-0",
      children: [function () {
        if (resource.lowest_price === null) {
          return null;
        }

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "rs-font mb-[2px] text-16 font-bold text-gray-1000 pc:text-15",
          children: function () {
            if (!resource.is_price_unique) {
              return "\xA5".concat(resource.lowest_price.toLocaleString(), "~");
            }

            return "\xA5".concat(resource.lowest_price.toLocaleString());
          }()
        });
      }(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
        children: paymentMethodsString
      })]
    })
  });
};

/***/ }),

/***/ 64368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ StaffList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _reservation_page_description_list_RSDescriptionList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96760);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var StaffList = function StaffList(_ref) {
  var staffMembers = _ref.staffMembers;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_reservation_page_description_list_RSDescriptionList__WEBPACK_IMPORTED_MODULE_1__/* .RSDescriptionList */ .m, {
    children: staffMembers.map(function (staff) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "box-border border-b border-l-0 border-r-0 border-t-0 border-solid border-gray-50  p-1.5 last-of-type:border-b-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "flex items-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: "mr-1.5 flex-none",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
              className: "h-[56px] w-[56px] rounded-full bg-gray-10",
              children: staff.image !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
                className: "block h-full w-full rounded-full",
                src: staff.image,
                alt: ""
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            className: "flex-auto",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("dt", {
              className: "rs-font text-16 font-bold text-gray-1000 pc:text-15",
              children: staff.name
            }), staff.description !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("dd", {
              className: "mb-0 ml-0 mr-0 mt-[2px]",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "rs-font text-16 font-normal text-gray-1000 pc:text-15",
                children: staff.description
              })
            })]
          })]
        })
      }, staff.canonical_id);
    })
  });
};

/***/ }),

/***/ 82011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSButtonAnchor_button--default__zFPnB","icon-wrapper":"RSButtonAnchor_icon-wrapper__Gol21","spin":"RSButtonAnchor_spin__7YM1v"};

/***/ }),

/***/ 46490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSDetailHeaderButton_button--default__nA5jZ","icon-wrapper":"RSDetailHeaderButton_icon-wrapper__5nXt3","spin":"RSDetailHeaderButton_spin__ctvCC"};

/***/ }),

/***/ 80957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayBase":"RSModal_overlayBase__IrpkF","overlayBaseAfterOpen":"RSModal_overlayBaseAfterOpen__EvsBf","overlayBaseBeforeClose":"RSModal_overlayBaseBeforeClose__W6P_q","contentBase":"RSModal_contentBase__ahyyJ","spContentBase":"RSModal_spContentBase__VMHXB","spContentAfterOpen":"RSModal_spContentAfterOpen__OuZBK","spContentBeforeClose":"RSModal_spContentBeforeClose__Zb455","contentBaseBeforeClose":"RSModal_contentBaseBeforeClose__WiWmr","pcHeightRestriction":"RSModal_pcHeightRestriction__iYbPx","mobileHeightRestriction":"RSModal_mobileHeightRestriction__O2oRS","headerTitle":"RSModal_headerTitle__xJoHd"};

/***/ })

}]);